import api from './axios';
import { ApiResponse } from '../types';

export const paymentsAPI = {
  // Paystack
  initializePaystack: async (data: {
    order_id: string;
    email: string;
    amount: number;
    currency?: string;
    card_only?: boolean;
  }) => {
    const res = await api.post<ApiResponse<{
      authorization_url: string;
      access_code: string;
      reference: string;
    }>>('/api/payments/paystack/initialize', data);
    return res.data;
  },

  verifyPaystack: async (reference: string) => {
    const res = await api.post<ApiResponse<{
      status: string;
      reference: string;
    }>>('/api/payments/paystack/verify', { reference });
    return res.data;
  },

  // PayPal
  initializePaypal: async (data: {
    order_id: string;
    amount: number;
    currency?: string;
  }) => {
    const res = await api.post<ApiResponse<{
      paypal_order_id: string;
      approve_url: string;
    }>>('/api/payments/paypal/initialize', data);
    return res.data;
  },

  capturePaypal: async (paypal_order_id: string) => {
    const res = await api.post<ApiResponse<{
      status: string;
      capture_id: string;
    }>>('/api/payments/paypal/capture', { paypal_order_id });
    return res.data;
  },

  // Stripe
  initializeStripe: async (data: {
    order_id: string;
    amount: number;
    currency?: string;
  }) => {
    const res = await api.post<ApiResponse<{
      client_secret: string;
      publishable_key: string;
      payment_intent_id: string;
    }>>('/api/payments/stripe/initialize', data);
    return res.data;
  },

  // Google Pay
  processGooglePay: async (data: {
    order_id: string;
    token_data: any;
    amount: number;
    currency?: string;
  }) => {
    const res = await api.post<ApiResponse<{
      transaction_id: string;
      status: string;
    }>>('/api/payments/google-pay/process', data);
    return res.data;
  },

  getPaymentStatus: async (order_id: string) => {
    const res = await api.get<ApiResponse<{
      payment_id: string;
      order_id: string;
      status: string;
      amount: number;
      currency: string;
      provider: string;
    }>>(`/api/payments/status/${order_id}`);
    return res.data;
  },
};